// extracted by mini-css-extract-plugin
export default {"notice":"ContactUs_notice__F2Ydp","content":"ContactUs_content__OgZoW"};